// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"33d56c0b","453":"8f77ead3"}[chunkId] + ".chunk.js";
};